import { ApplicationIcon } from '@/const'
import { useCurrentApplication } from './useCurrentApplication'
import { DEFAULT_HEADER_STATE, useSetHeaderContext } from '@/layouts/MainLayout/HeaderContext'
import { IconDatabricksOutline } from '@icons/IconDatabricksOutline'
import {
  AppGeneric24Regular,
  Notepad24Regular,
  BoardSplit24Regular,
  TextBulletList24Regular,
  PersonBoard24Regular,
  GridRegular,
  Box24Regular,
} from '@fluentui/react-icons'
import { isDagsterApp, isDatabricksApp } from '@/util/appTypes'
import { CheckboxPerson24Regular, CubeSync24Regular } from '@fluentui/react-icons'
import { IconDagsterOutline } from '@icons/IconDagsterOutline'
import { IconV2SettingsOutline } from '@icons/IconV2SettingsOutline'
import { IconV2FolderOutline } from '@icons/IconV2FolderOutline'
import { FlatSidebarMenu } from '@/components/ui/FlatSidebarMenu'
import { IconV2LightbulbOutline } from '@icons/IconV2LightbulbOutline'
import { Book24Regular } from '@fluentui/react-icons'
import { IconDocumentPoliciesOutline } from '@icons/IconDocumentPoliciesOutline'
import { IconShieldCheckOutline } from '@icons/IconShieldCheckOutline'

const navigation = (appTypes: number) => [
  { title: 'Details', Icon: AppGeneric24Regular, path: '.', visible: true },
  { title: 'Menu builder', Icon: TextBulletList24Regular, path: 'menu', visible: true },
  { title: 'Roles', Icon: PersonBoard24Regular, path: 'roles', visible: true },
  { title: 'Permissions', Icon: CheckboxPerson24Regular, path: 'perms', visible: true },
  { title: 'Accesses', Icon: CheckboxPerson24Regular, path: 'accesses', visible: true },
  { title: 'Teams', Icon: PersonBoard24Regular, path: 'teams', visible: true },
  { title: 'Pages', Icon: Notepad24Regular, path: 'pages', visible: true },
  { title: 'Page Builder', Icon: GridRegular, path: 'page-builder', visible: true },
  { title: 'File Manager', Icon: IconV2FolderOutline, path: 'file-manager', visible: true },
  { title: 'Marketing', Icon: BoardSplit24Regular, path: 'marketing', visible: true },
  { title: 'Sync', Icon: CubeSync24Regular, path: 'sync', visible: true },
  { title: 'Databricks', Icon: IconDatabricksOutline, path: 'databricks', visible: isDatabricksApp(appTypes) },
  { title: 'Dagster', Icon: IconDagsterOutline, path: 'dagster', visible: isDagsterApp(appTypes) },
  { title: 'Settings', Icon: IconV2SettingsOutline, path: 'settings', visible: true },
  { title: 'Container Logs', Icon: Box24Regular, path: 'container-logs', visible: true },
  { title: 'FAQ', Icon: IconV2LightbulbOutline, path: 'faq', visible: true },
  { title: 'Glossary', Icon: Book24Regular, path: 'glossary', visible: true },
  { title: 'Terms & Conditions', Icon: IconDocumentPoliciesOutline, path: 'terms', visible: true },
  { title: 'Privacy Policy', Icon: IconShieldCheckOutline, path: 'privacy-policy', visible: true },
]

export function ApplicationNavMenu({ sidebarOpen = true }: { sidebarOpen?: boolean }) {
  const { appName: applicationName, appTypes } = useCurrentApplication()

  useSetHeaderContext({
    ...DEFAULT_HEADER_STATE,
    rightTitle: applicationName ? { text: applicationName, icon: ApplicationIcon } : undefined,
  })

  return <FlatSidebarMenu items={navigation(appTypes)} sidebarOpen={sidebarOpen} />
}
